import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {
  defaultTableChange,
  defaultTableChange1,
} from "../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../../modules/SimpleDate";
import CrmCDBFilter from "./crmCDBFilter";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import CrmCDBDetail from "./crmCDBDetail";
import { config } from "../config";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import M from "moment";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { defaultTableChangeProspek } from "../tableChangeProspek";
import { getValueFromDDL } from "../../../../common/mapper";

class CrmCDBTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataTableMotor: [],
      selectedRowIndex: [],
      pagination: {
        totalData: 0,
        page: 1,
        limit: 5,
      },
    };
  }

  handleChangePage = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
      selectedRowIndex: [], 
      selectedData: [],
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
      selectedRowIndex: [], 
      selectedData: [],
    }));
  };

  componentDidUpdate(prevProps, prevState) {
    const prevKodeCabang = prevProps.state.kodeCabang;
    const currentKodeCabang = this.props.state.kodeCabang;

    if (prevProps.state.filterData !== this.props.state.filterData) {
      this.setState({ dataTableMotor: [] });
    }

    if (
      prevKodeCabang !== currentKodeCabang &&
      (currentKodeCabang === null || currentKodeCabang === "")
    ) {
      this.setState({ dataTableMotor: [] });
    }

    if (prevProps.state.dataTable !== this.props.state.dataTable) {
      this.setState({ dataTableMotor: [] });
    }
  }

  handleRowClick = (rowData, rowMeta) => {
    this.fetchDataListMotor(rowData[8]);
  };

  fetchDataListMotor = async (idMember) => {
    let filter = this.props.state.filterData?.filterH1 || {};

    let startDateFJ = filter.startDateFJ || filter.tanggalFJ?.startDateFJ;
    let endDateFJ = filter.endDateFJ || filter.tanggalFJ?.endDateFJ;

    let series =
      Array.isArray(filter.listSeries) &&
      typeof filter.listSeries[0] === "object"
        ? filter.listSeries.map((item) => item.value)
        : filter.listSeries;
    let tipe =
      Array.isArray(filter.listTipe) && typeof filter.listTipe[0] === "object"
        ? filter.listTipe.map((item) => item.value)
        : filter.listTipe;
    let varian =
      Array.isArray(filter.listVarian) &&
      typeof filter.listVarian[0] === "object"
        ? filter.listVarian.map((item) => item.value)
        : filter.listVarian;
    let warna =
      Array.isArray(filter.listWarna) && typeof filter.listWarna[0] === "object"
        ? filter.listWarna.map((item) => item.value)
        : filter.listWarna;

    let updatedFilter = {
      ...filter,
      listSeries: series,
      listTipe: tipe,
      listVarian: varian,
      listWarna: warna,
      startDateFJ: startDateFJ,
      endDateFJ: endDateFJ,
      jenisPenjualan: getValueFromDDL(filter, "jenisPenjualan"),
      jenisKonsumen: getValueFromDDL(filter, "jenisKonsumen"),
      leasing: getValueFromDDL(filter, "leasing"),
      operatorTanggalBeliTerakhir: getValueFromDDL(
        filter,
        "operatorTanggalBeliTerakhir"
      ),
    };

    delete updatedFilter.tanggalFJ;

    this.handleTriggerLoading();

    let request = {
      memberId: idMember,
      limit: 5,
      page: 1,
      ...(this.props.state.cekfilter ? { filterH1: updatedFilter } : {}),
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getListDataMotorByMemberId,
      menuName: "Management CDB",
      setError: this.props.setError,
      args: request,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTableMotor: res.data.data,
        pagination: {
          ...prevValue.pagination,
          totalData: res.data.totalData,
        },
      }));
    }

    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleOnRowSelected = (listIndex) => {
    const selectedData = listIndex.map((index) => this.dataForTable[index]);

    this.props.onSetState((prevValue) => ({
      ...prevValue,
      selectedData: selectedData,
      selectedRowIndex: listIndex,
    }));
  };

  handleChangePage2 = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination2: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage2 = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination2: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleModalDetailVisibility = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      detailVisible: !prevValue.detailVisible,
    }));
  };

  handleDisplayAllAlert = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      displayAllVisible: !prevValue.displayAllVisible,
    }));
  };

  handleDisplayAll = () => {
    this.handleDisplayAllAlert();
    this.props.onDisplayAll();
  };

  onValueChange = (name, value) => {
    this.props.onSetState((prevState) => ({
      ...prevState,
      filterData: {
        ...prevState.filterData,
        filterCDB: {
          ...prevState.filterData.filterCDB,
          [name]: value,
        },
      },
    }));
  };

  render() {
    const selectionMode =
      this.props.state.dataTable.length > 1 ? "multiple" : "single";
    const dataWithNumbering = this.props.state.dataTable.map((item, index) => ({
      ...item,
      no: index + 1,
    }));

    this.dataForTable = dataWithNumbering;
    return (
      <>
        {this.props.tab === "create_prospek" ? (
          <FlexView column style={{ gap: 20 }}>
            <FlexView>
              <SimpleButton
                text="TAMPILKAN SEMUA"
                onClick={this.handleDisplayAllAlert}
              />
              <SimpleButton
                text="TAMPILKAN BY FILTER"
                onClick={this.props.onFilterVisibility}
              />
            </FlexView>
            <SimpleDataTable
              title="LIST CALON PROSPEK"
              data={dataWithNumbering}
              columns={this.props.state.tableColumns}
              toCount={this.props.state.pagination.totalData}
              rowsPerPage={this.props.state.pagination.limit}
              page={this.props.state.pagination.page - 1}
              options={{
                selectableRows: true,
                rowsSelected: this.props.state.selectedRowIndex,
                ...defaultTableChange1(
                  this.handleChangePage,
                  this.handleRowsPerPage,
                  (e) => this.handleOnRowSelected(e),
                  this.handleRowClick
                ),
              }}
              // rowsPerPage={5}
              // page={0}
              // options={{
              //   selectableRows: selectionMode,
              //   serverSide: false,
              //   rowsSelected: this.props.state.selectedRowIndex,
              //   ...defaultTableChangeProspek(
              //     (e) => this.handleOnRowSelected(e),
              //     this.handleRowClick
              //   ),
              // }}
            />
            <SimpleDataTable
              title="LIST MOTOR YANG DIMILIKI"
              data={this.state.dataTableMotor}
              columns={this.props.state.tableColumns2}
              toCount={this.props.state.pagination2.totalData}
              rowsPerPage={this.props.state.pagination2.limit}
              page={this.props.state.pagination2.page - 1}
              options={defaultTableChange(
                this.handleChangePage2,
                this.handleRowsPerPage2
              )}
            />
          </FlexView>
        ) : (
          <>
            <FlexView
              style={{ justifyContent: "space-between" }}
              vAlignContent="center"
            >
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <p className="margin-bottom-20px">Periode</p>
                <SimpleDate
                  id="select_date_startTanggalPengajuan"
                  name="startDatePeriod"
                  nextdate
                  date={
                    this.props.state.filterData?.filterCDB?.["startDatePeriod"]
                  }
                  maxDate={
                    this.props.state.filterData?.filterCDB?.["endDatePeriod"]
                  }
                  onChange={(value) =>
                    this.onValueChange(
                      "startDatePeriod",
                      M(value).format("DD-MM-YYYY")
                    )
                  }
                />
                <SimpleDate
                  id="select_date_endTanggalPengajuan"
                  name="endDatePeriod"
                  nextdate
                  date={
                    this.props.state.filterData?.filterCDB?.["endDatePeriod"]
                  }
                  onChange={(value) =>
                    this.onValueChange(
                      "endDatePeriod",
                      M(value).format("DD-MM-YYYY")
                    )
                  }
                />
                <SimpleButton
                  text="Cari"
                  className="margin-bottom-15px"
                  onClick={() => this.props.onSubmitSearch(true)}
                />
              </FlexView>
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton
                  category="action_button"
                  className="btn background-red margin-bottom-15px"
                  icon={
                    <span>
                      <i className="fa fa-qrcode"></i>
                    </span>
                  }
                  onClick={this.props.onFilterVisibility}
                />
              </FlexView>
            </FlexView>
            <SimpleDataTable
              title="LIST CALON PROSPEK"
              data={dataWithNumbering}
              columns={this.props.state.tableColumns}
              toCount={this.props.state.pagination.totalData}
              rowsPerPage={this.props.state.pagination.limit}
              page={this.props.state.pagination.page - 1}
              options={defaultTableChange(
                this.handleChangePage,
                this.handleRowsPerPage
              )}
              // options={{
              //   selectableRows: selectionMode,
              //   serverSide: false,
              //   ...defaultTableChangeProspek(
              //     (e) => this.handleOnRowSelected(e),
              //     this.handleRowClick
              //   ),
              // }}
            />
          </>
        )}

        {this.props.state.filterVisible && (
          <CrmCDBFilter
            tab={this.props.tab}
            state={this.props.state}
            onResetFilter={this.props.onResetFilter}
            onSetState={this.props.onSetState}
            onClickClose={this.props.onFilterVisibility}
            onSubmitFilter={this.props.onSubmitFilter}
          />
        )}

        {this.props.state.detailVisible && (
          <CrmCDBDetail
            state={this.props.state}
            activeTab={this.props.state.activeTab}
            activityType={this.props.state.activityType}
            formGroup={config.formGroup}
            initialValues={this.props.state.selectedData}
            onSetState={this.props.onSetState}
            onClickClose={this.handleModalDetailVisibility}
            onSubmit={this.props.onSubmit}
            onCancel={this.props.onCancel}
            onProcess={this.props.onProcess}
          />
        )}

        {this.props.state.displayAllVisible && (
          <SimpleAlert
            title={"Information"}
            visible={this.props.state.displayAllVisible}
            onClickClose={this.handleDisplayAllAlert}
            content={
              "Terdapat kemungkinan proses loading yang lama jika semua data ditampilkan. Anda yakin ingin menampilkan semua data?"
            }
            additionalButtons={
              <FlexView vAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton onClick={this.handleDisplayAllAlert}>
                  Batal
                </SimpleButton>
                <SimpleButton onClick={this.handleDisplayAll}>Iya</SimpleButton>
              </FlexView>
            }
          />
        )}

        {this.props.state.loading && (
          <SimpleLoadingOverlay active={this.props.state.loading} />
        )}
      </>
    );
  }
}

export default CrmCDBTab;
